import $ from 'jquery'
import Paginator from './paginator'
import settings from '../utils/settings'
import cookies from '../utils/cookies'
import '../plugins/dropdown'

export default class AjaxList {
  constructor (options) {
    this.options = $.extend(
      {
        $container: null,
        $form: null,
        $sorting: null,
        $load: null,
        prefix: null,
        append: (response, replace) => {}
      },
      options || {}
    )

    this.sorting = this.buildSorting()
    this.paginator = this.buildPaginator()
    this.formValue = null

    this.bind()
  }

  buildSorting () {
    const $sorting = this.options.$sorting

    return {
      field: $sorting ? $sorting.data('field') : null,
      direction: $sorting ? $sorting.data('direction') : null
    }
  }

  buildPaginator () {
    const $btn = this.options.$load

    return new Paginator({
      $btn: $btn,
      page: $btn ? $btn.data('page') : 1,
      total: $btn ? $btn.data('total-pages') : 1,
      params: () => {
        const params = {}

        if (this.options.$sorting) {
          params.sort_field = this.sorting.field
          params.sort_direction = this.sorting.direction
        }

        if (this.options.$form) {
          this.options.$form.serializeArray().map((v) => {
            if (this.isArrayInput(v.name)) {
              if (typeof params[v.name] === 'undefined') {
                params[v.name] = []
              }

              params[v.name].push(v.value)
            } else {
              params[v.name] = v.value
            }
          })
        }

        return params
      }
    })
  }

  isArrayInput (name) {
    return $('input[name="' + name + '"]').length > 1
  }

  bind () {
    const self = this

    if (this.options.$sorting) {
      this.options.$sorting.dropdown({
        mode: 'switch',
        onItemClick: function () {
          self.setSorting($(this).data('field'), $(this).data('direction'))
        }
      })
    }

    if (this.options.$load) {
      this.options.$load.click((e) => {
        e.preventDefault()

        this.options.$container.addClass('loading')
        this.paginator.next((response) => {
          this.options.$container.removeClass('loading')
          this.options.append(response)
        })
      })
    }

    if (this.options.$form) {
      this.options.$form.submit((e) => {
        e.preventDefault()

        this.options.$container.addClass('refreshing')
        this.paginator.reset((response) => {
          this.options.$container.removeClass('refreshing')
          this.options.append(response, true)
        })
      })

      this.options.$form.find('input').on('keyup change', (e) => {
        
        if (typeof this.inputTimeout !== 'undefined') {
          clearTimeout(this.inputTimeout)
        }

        this.inputTimeout = setTimeout(() => {
          const serialized = this.options.$form.serialize()

          if (this.formValue !== serialized) {
            this.options.$form.trigger('submit')
            this.formValue = serialized
          }
        }, settings.FORM_TIMEOUT)
      })
    }
  }

  setSorting (field, direction) {
    if (field === this.sorting.field && direction === this.sorting.direction) {
      return
    }

    this.sorting.field = field
    this.sorting.direction = direction

    cookies.set(this.options.prefix + '_sort_field', field)
    cookies.set(this.options.prefix + '_sort_direction', direction)

    if (this.options.$form) {
      this.options.$form.trigger('submit')
    }
  }
}
